<template>
	<div class='tree-list-filter-component'>
		<b-dropdown ref='filterDropdown' class='lpo-filter-dropdown' :text='text' @show='onShow' variant='dark' :class='{ active: this.columnIsFiltered(column) }'>
			<div class='filter-lpo-dropdown-content'> 
				<div class='lpo-filter-dropdown-header'>
					<custom-p-input v-model='searchInput' placeholder='Поиск...'/>
					<button @click='clearCheckedItems' class='clear-filter-list-btn'>Снять выделения</button>
				</div>

				<div>
					<ul class='filter-list'>
						<li v-for='item in filterList' v-if='matchToSearch(item)' class='li-item'>
							<custom-p-checkbox
								v-model='checkedItems'
								multiple
								:multipleValue='item'
								:label='item ? ((column == "layer" && item == "11") ? "единичные деревья": item) : "(пусто)"'
							/>
						</li>
					</ul>
					<button class='custom-sm-btn ok-btn' @click.prevent='applyFilter'>Применить</button>
				</div>
			</div>
		</b-dropdown>
	</div>
</template>

<script>
	export default {
		name: 'TreeListFilterComponent',
		props: {
			column: String,
			activeFilter: Object,
			text: {
				type: String,
				default: ''
			},
			treeList: {
				type: Array,
			},
			filterObj: {
				type: Object
			}
		},
		data: () => ({
			searchInput: null,
			checkedItems: [],
			// filterList: [],
		}),
		computed: {
			filterList() {
				return this.filteredList.map(tree => tree[this.column]).filter((value, index, self) => {
					return self.indexOf(value) === index;
				});
			},

			filteredList() {
				return this.treeList.filter(tree => {

					for (const column in this.filterObj) {

						if (column === this.column) {
							continue;
						}

						if (!this.filterObj[column].length) {
							continue;
						}

						if (!this.filterObj[column].find(item => item === tree[column])) {
							return false;
						}

					}

					return true;

				});
			},
		},
		methods: {
			onShow() {
				// this.clearFilterList();
				// this.getFilterList(this.column);
				// this.restoreCheckedItems();

				// this.searchInput = '';
			},
			columnIsFiltered() {
				return this.filterObj[this.column].length
				console.log('lalalal');
			},

			clearCheckedItems() {
				this.checkedItems = [];
			},

			applyFilter() {
				this.$refs.filterDropdown.hide(true);
				this.$emit('apply-filter', { items: this.checkedItems, column: this.column });
			},

			matchToSearch(item) {
				if (item === null && (this.searchInput === null || this.searchInput === '') ) return true;
				else if (item === null) return false;
				if (this.searchInput === null || this.searchInput === '') return true;
				if ( item.toLowerCase().includes(this.searchInput.toLowerCase()) )
					return true;
				return false;
			},
		}
	};
</script>

<style>

	.tree-list-filter-component .filter-list {
		margin-top: 10px;
		list-style-type: none;
		padding: 6px;
		max-height: 400px;
		overflow-y: auto;
		width: 200px;
		font-size: 14px;

		border: 1px solid #999;
		width: 100%;
		min-width: 200px;
	}

	.tree-list-filter-component .dropdown.active > .dropdown-toggle {
		background-color: dodgerblue;
	}

	.tree-list-filter-component .dropdown.btn-group {
		width: 100%;
	}
	.tree-list-filter-component .dropdown.b-dropdown .b-dropdown-form {
		padding: 0;
	}
	.tree-list-filter-component .b-dropdown .dropdown-menu {
		box-shadow: 0px 0px 3px gray;
	}
	

	.tree-list-filter-component .dropdown > .dropdown-toggle {

		font-size: 12px;
		padding: 6px 2px;
		width: 100%;
	}

	.tree-list-filter-component .dropdown.active > .dropdown-toggle {
		background-color: dodgerblue;
	}

	.tree-list-filter-component .li-item {
		margin-bottom: 8px;
	}


	.tree-list-filter-component .filter-lpo-dropdown-content {
		padding: 10px;
		padding-bottom: 4px;
	}

	.tree-list-filter-component .lpo-filter-dropdown-header {

		/*margin: auto;
		width: 95%;*/
	}
	.tree-list-filter-component .lpo-filter-dropdown-header > input {
		font-size: 14px;
		padding-left: 8px;
		width: 100%;
	}
	.tree-list-filter-component .lpo-filter-dropdown-header > .clear-filter-list-btn {

		background-color: #343a40;
		border: none;
		color: white;
		font-size: 14px;
		outline: none;

		margin-top: 16px;
		width: 100%;
	}

	.tree-list-filter-component .filter-table-lpo-filter-list {
		margin-top: 10px;
		list-style-type: none;
		padding: 6px;
		max-height: 400px;
		overflow-y: auto;
		width: 200px;
		font-size: 14px;

		border: 1px solid #999;
		width: 100%;
		min-width: 200px;
	}

	.tree-list-filter-component .filter-table-lpo-filter-list .filter-list-item {
		cursor: pointer;
		margin-left: 4px;
		font-weight: normal;
		font-size: 0.9rem;
	}
	.tree-list-filter-component .filter-table-lpo-filter-list .empty-filter-list-item {
		color: #aaa;
	}

	.tree-list-filter-component .filter-lpo-dropdown-content .ok-btn {
		float: right;
		margin-top: 10px;
	}

</style>